import React, { useState } from 'react';
import { useParams } from 'react-router';

import { useGetVariantCommentsQuery } from '../../api/variantApi';
import DetailCard from '../components/DetailCard';
import LoadMoreBtn from '../components/LoadMoreBtn';
import MolecularImpactHeader from '../molecular_impact/MolecularImpactHeader';
import VariantCommentsTable from '../summary/VariantCommentsTable';
import VariantHistory from '../summary/VariantHistory';

type InterpretationHeaderSectionProps = {
  forceExpanded?: boolean;
};

const InterpretationHeaderSection = ({
  forceExpanded = false,
}: InterpretationHeaderSectionProps) => {
  const [showMore, setShowMore] = useState(true);
  const params = useParams();
  const isExpanded = forceExpanded || showMore;

  const handleShowMoreClick = () => {
    setShowMore((v) => !v);
  };
  // Read comments straight from the query hook's cache rather than a selector
  const { data: variantComments } = useGetVariantCommentsQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  return (
    <DetailCard>
      <MolecularImpactHeader />
      {isExpanded && (
        <div className="interpretation__comments-table">
          {variantComments && variantComments.length > 0 && (
            <div data-snapshot-exclude="true">
              <h3>Comments</h3>
              <VariantCommentsTable />
            </div>
          )}

          <h3 style={{ marginTop: '2rem' }}>Variant history</h3>
          <VariantHistory />
        </div>
      )}

      <LoadMoreBtn
        showMore={isExpanded}
        handleShowMoreClick={handleShowMoreClick}
      />
    </DetailCard>
  );
};

export default InterpretationHeaderSection;
